var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9389 8.70002C26.6998 7.38049 25.5607 6.41956 24.2389 6.11956C22.2607 5.70002 18.5998 5.40002 14.6389 5.40002C10.6803 5.40002 6.96074 5.70002 4.98027 6.11956C3.66074 6.41956 2.51934 7.31956 2.28027 8.70002C2.03887 10.2 1.7998 12.3 1.7998 15C1.7998 17.7 2.03887 19.8 2.33887 21.3C2.58027 22.6196 3.71934 23.5805 5.03887 23.8805C7.13887 24.3 10.7389 24.6 14.6998 24.6C18.6607 24.6 22.2607 24.3 24.3607 23.8805C25.6803 23.5805 26.8193 22.6805 27.0607 21.3C27.2998 19.8 27.5998 17.6391 27.6607 15C27.5389 12.3 27.2389 10.2 26.9389 8.70002ZM11.3998 19.2V10.8L18.7193 15L11.3998 19.2Z",
    fill: "#131C12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeGreen);
export default __webpack_public_path__ + "static/media/youtube-green.e0e43aeccf6ad0f098365c6e37e27e46.svg";
export { ForwardRef as ReactComponent };